<script>
	import AutoComplete from "simple-svelte-autocomplete";
    import fetchNode from "../helpers/FetchNode.js";

    export let selected;
    export let placeholder = '';
    export let node;
    export let labelFieldName = 'name';
    export let valueFieldName = 'name';
    const request = fetchNode(node,{limit:1000});

    const isEmpty = (value) => value ? Object.keys(value).length !== 0 : false;
</script>
{#await request then items}
	<AutoComplete items={items} bind:value={selected} valueFieldName='{valueFieldName}' labelFieldName='{labelFieldName}' hideArrow=true placeholder='{placeholder}' name='autocomplete{node}' showClear='{isEmpty(selected)}'  /> 
{/await}

<style>

</style>
